exports.transient$Props = {
    shouldForwardProp: (prop) => prop[0] !== '$'
};
